import type { CSSProperties, ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from './cn';

/** Ant Design `Empty` replacement — a centered "no data" placeholder. */
const SIMPLE = Symbol('empty-simple');
const DEFAULT = Symbol('empty-default');

export interface EmptyProps {
  description?: ReactNode;
  image?: ReactNode | symbol;
  imageStyle?: CSSProperties;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

function EmptyBase({ description = 'No data', image, imageStyle, className, style, children }: EmptyProps) {
  const custom = image != null && typeof image !== 'symbol';
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 px-4 py-8 text-center', className)} style={style}>
      <div className="text-subtle" style={imageStyle}>
        {custom ? (image as ReactNode) : <Inbox className="size-10 opacity-40" strokeWidth={1.4} />}
      </div>
      {description != null && description !== false && <div className="text-sm text-muted">{description}</div>}
      {children}
    </div>
  );
}

export const Empty = Object.assign(EmptyBase, {
  PRESENTED_IMAGE_SIMPLE: SIMPLE,
  PRESENTED_IMAGE_DEFAULT: DEFAULT,
});
